module.exports = __webpack_public_path__ + "dashboard/img/doublebrackets_left.37ad77ce5b3b424399c25fd2150907b1.svg";